import styled from "styled-components"
import { colors, device } from "../styles/stylesConfig"
import { useDispatch, useSelector } from "react-redux"
import { finishLoading } from "../actions/ui"
import { useAnimations } from "../effects/Effects"
import { useLogEvent } from "../hooks/useLogEvent"
import { useTranslation } from 'react-i18next';

const Container = styled.div`
    width: 100vw;
    height: 110vh;
    display: flex;
    flex-direction: row;
    justify-content: start;
    align-items: center;
    position: relative;
    z-index: 1;
    overflow: hidden;
    background-color: ${colors.dark};

    @media ${device.lg} {
        justify-content: center;
    }

    &::before {
        content: '';
        position: absolute;
        margin: auto;
        width: 100vw;
        top: 0px;
        height: 120vh;
        background-color: ${colors.dark};
        opacity: 0.20;
        z-index: 1;
    }

    &::after {
        content: '';
        position: absolute;
        margin: auto;
        width: 150%;
        height: 200px;
        left: -50%;
        bottom: -200px;
        background-color: ${colors.dark};
        box-shadow: 50px -75px 20px 0px ${colors.dark};
    }
`

const Img = styled.img`
    width: 100%;
    height: 100%;
    position: absolute;
    top: 0;
    left: 0;
    object-fit: cover;


`

const InfoContainer = styled.div`
    z-index: 10;
    color: white;
    display: flex;
    flex-direction: column;
    padding: 0px 5%;

    @media ${device.lg} {
        align-items: center;
    }
`

const Title = styled.h1`
    color: #fff;
    font-size: 3.5vw;
    font-weight: bold;

    @media ${device.lg} {
        font-size: 5vw;
        text-align: center;
    }
    
    @media ${device.md} {
    }
    
    @media ${device.sm} {
        font-size: 7vw;
    }
    
    @media ${device.xs} {
        
    }
    
    `

const Subitle = styled.p`
    color: #fff;
    font-size: 1.5vw;
    margin-top: 10px;
    
    @media ${device.lg} {
        font-size: 2vw;
        text-align: center;
    }

    @media ${device.md} {
        font-size: 2.2vw;
    }
    
    @media ${device.sm} {
        font-size: 3vw;

    }

    @media ${device.xs} {
        font-size: 3.2vw;
        
    }
    
`

const Action = styled.button`
    background-color: ${colors.primary};
    padding: 10px 20px;
    border-radius: 10px;
    color: #fff;
    font-weight: 400;
    font-size: 16px;
    margin-top: 50px;
    box-shadow:  0px 0px 8px 0px rgba(0, 0, 0, 0.5);
    width: fit-content;


    @media ${device.sm} {
        font-size: 12px;
        margin-top: 30px;
    }

    @media ${device.xs} {
        font-size: 11px;
        padding: 10px 20px;
    }
    
`

export const Introduction = () => {

    const { t } = useTranslation();

    const dispatch = useDispatch()

    const { handleLogEvent } = useLogEvent();

    const { loading } = useSelector((state: any) => state.ui);

    const {
        handleClickGoProducts,
    } = useAnimations()

    return (

        <Container id="home">

            <Img
                src={require('../images/intro-bg.webp')}
                alt="Discos de corte"
                loading="eager"
                onLoad={() => dispatch(finishLoading())}
            />

            <InfoContainer>

                <Title className={!loading ? "utils__fade-in-right" : ''}>{t('introduction.title')}<br />{t('introduction.title.2')}</Title>

                <Subitle className={!loading ? "utils__fade-in-left" : ''}>{t('introduction.subtitle')}<br />{t('introduction.subtitle.2')}</Subitle>

                <Action
                    className={!loading ? "utils__fade-in-top" : ''}
                    onClick={async (e: any) => {

                        handleClickGoProducts()

                        handleLogEvent('click_boton_descubrir_productos');

                        e.target?.blur()

                    }}>
                    {t('introduction.title.button')}
                </Action>

            </InfoContainer>

        </Container >


    )
}

export default Introduction;